import React, { useContext, useState } from "react";
import Table from "../Shared/Table";

import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Button,
} from "reactstrap";

import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import { customer } from "core/UrlEndpoints";
import { useHistory } from "react-router-dom";
import { UserContext } from "context/UserContext";
import reportService from "core/api/ReportService";

const CustomerList = () => {
  const history = useHistory();
  const { userHasAnyPermissions } = useContext(UserContext);
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    setIsExporting(true);
    try {
      await reportService.downloadCustomerReport();
    } catch (error) {
      console.error("Export failed:", error);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <>
      <PanelHeader
        content={
          <div className="header text-center">
            <h2 className="title">Customers</h2>
          </div>
        }
      />
      <div className="content">
        <Row>
          <Col xs={12} md={12}>
            <Card>
              <CardHeader style={{ position: "relative" }}>
                <CardTitle tag="h4">Customers</CardTitle>
                <Button
                  color="primary"
                  onClick={() => history.push(`customers/add`)}>
                  Add
                </Button>
                {userHasAnyPermissions(["all:reports", "read:reports", "admin"]) && (
                  <Button
                    color="primary"
                    onClick={handleExport}
                    disabled={isExporting}
                    style={{ position: "absolute", right: "25px", top: "15px" }}>
                    Export to Excel
                  </Button>
                )}
              </CardHeader>
              <CardBody>
                <Table
                  url={customer}
                  hideDataUntilFilter={!userHasAnyPermissions(["admin"])}
                  columns={[
                    {
                      header: "Company",
                      accessorKey: "company",
                    },
                    {
                      header: "Name",
                      accessorKey: "name",
                    },
                    {
                      header: "Address",
                      accessorKey: "line1",
                      cell: ({ row }) => (
                        <>
                          {row.original.line1} {row.original.line2},{" "}
                          {row.original.city} {row.original.state}
                        </>
                      ),
                    },
                    {
                      header: "Phone",
                      accessorKey: "phone",
                    },
                    {
                      header: "Email",
                      accessorKey: "email",
                    },
                    {
                      header: "Send Alerts",
                      accessorKey: "sendAlerts",
                      cell: ({ row }) => (
                        <>{row.original.sendAlerts ? "True" : ""}</>
                      ),
                    },
                  ]}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default CustomerList;
